export const DatasetTypes = {
    Indicator: 'indikator',
    Table: 'table',
    Raster: 'raster',
    CustomIndicator: 'custom indikator',
    SensorThings: 'SensorThings',
    UploadedGeojson: 'geojson'
}